import { render, staticRenderFns } from "./DepartmentsUsers.vue?vue&type=template&id=13b4532e&scoped=true"
import script from "./DepartmentsUsers.vue?vue&type=script&lang=js"
export * from "./DepartmentsUsers.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsUsers.vue?vue&type=style&index=0&id=13b4532e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b4532e",
  null
  
)

export default component.exports